// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1UiEX","requiredAsterisk":"Info_requiredAsterisk__1Tn3v"};